<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    爱联站<br>
站点介绍<br>
爱联地铁站位于龙岗大道中与如意路交汇处。东侧有恒大城市之光在建，西侧名居广场在建，西北是爱联小学，西南有COCO PARK商场。附近属于龙岗在建阶段，蓬勃发展，爱联周边4公里内有幼儿园小学医院住宅商业圈等。出入口BC出入口有盲道铺设。该站位为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:29	23:09	3号线	2分15-20秒	4分30秒<br>
双龙	06:14	00:03	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:29	23:09	3号线	3分15秒	5分钟<br>
双龙	06:17	00:02	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:29	00:09	3号线	3分15秒	5分钟<br>
双龙	06:17	01:02	3号线	3分15秒	5分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
如意南路、爱联社区 、爱联天桥、爱联第二市场、爱联派出所、爱联邮电局、爱联股份大厦（高德地图显示为千百年商业大厦）<br><br>
B出入口:<br>
龙岗大道（南）、蒲排路、新屯村、牛仔围村、恒大城市之光<br><br>
C出入口:<br>
龙岗大道（北）、爱联小学、晨光路、保利上城、翡翠明珠花园 、田寮村、名居广场、爱联社区街道办<br><br>
D出入口:<br>
龙岗大道（北）、龙城华府、老干中心、爱联天桥、建新社区、向前社区、爱联如意小区、天光城、中粮祥云小区<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 爱联地铁站<br>
358路,811路,833路，E23路，E33路，E34路，A4路，M359路,M396路,M546路,甘坑客家小镇假日专线3，深惠3AB出入口<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>



